module.exports = __webpack_public_path__ + "img/image-title-casual.5163f937.png";